import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ReactSelectize, SimpleSelect } from 'react-selectize';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import $ from 'jquery';
import Formsy from 'formsy-react';
import { Heading, Header, Slider, Section, MapsItems, FormValidation, FormRegister,
  MapDetail, Loader, Field } from '../components/index';
import { data } from '../utils/config';
import { pad, getDataUri } from '../utils/_helpers';
import REQUEST from '../api/requests';
import Errors from '../utils/errors';

const defaultProps = {
  page: 0,
    files: [],
    number: '',
    id: '',
    loadingValidate: false,
    loadingVerifying: false,
    validatedData: {},
    canSubmitWithImg: false,
    canSubmitWithNumber: false,

    errorOnVerifying: '',
    errorOnValidate: '',

    successOnVerifying: false,
};

export default class Validate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      files: [],
      number: '',
      id: '',
      loadingValidate: false,
      loadingVerifying: false,
      validatedData: {},
      canSubmitWithImg: false,
      canSubmitWithNumber: false,

      errorOnVerifying: '',
      errorOnValidate: '',
      
      width: '',
      height: '',

      successOnVerifying: false,
    };
    this.goTo = this.goTo.bind(this);
    this.generateBase64 = this.generateBase64.bind(this);
    this.tryVerifyQR = this.tryVerifyQR.bind(this);
    this.tryValidateNumber = this.tryValidateNumber.bind(this);
    this.reset = this.reset.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    this.setState({ width: $(window).width(), height: $(window).height() });
  }

  reset() {
    this.setState({
      canSubmitWithImg: false,
      loadingVerifying: false,
      errorOnVerifying: '',
      successOnVerifying: false,
      files: [],
    });
  }

  goTo(page) {
    this.setState({ page });
  }

  onDrop(files) {
    this.setState({
      files,
      canSubmitVerify: true,
      errorOnVerifying: '',
      successOnVerifying: false,
    });
  }

  generateBase64(file) {
    const that = this;
    return new Promise((resolve, reject) => {
      if (!file) reject(Errors.noFileProvided);
      getDataUri(file.preview, (base64) => {
        resolve(base64);
      });
    })
  }

  tryValidateNumber(response) {
    const id = this.state.id;
    if (response && (id !== '' && response.number !== '')) {
      this.setState({
        loadingValidate: true,
        errorOnValidate: '',
      }, () => {
        const searchObj = this.props.data.find(item => item.id === id);
        this.props.fetchMapDetails(id, response.number)
          .then((res) => {
            if (res.data && res.status === 200 && res.data.status) {
              this.props.openDataWithPrint(searchObj, response.number);
              this.setState({
                loadingValidate: false,
                id: ''
              }, () => {
                this.refs.form_varify_number.reset();
                // hook to reset selectize
                this.refs.select_map.setState({ value: null}); 
              });
            }
            else if (res.data && res.status === 200 && !res.data.status) {
              this.setState({
                loadingValidate: false,
                errorOnValidate: res.data.message || res.data.errorMessage,
              });
            }
            else {
              this.setState({
                loadingValidate: false,
                errorOnValidate: Errors.default,
              });
            }
          })
          .catch(err => {
            this.setState({
              loadingValidate: false,
              errorOnValidate: err.message,
            });
          });
      })
    }
  }

  tryVerifyQR(file) {
    this.props.onDisableRegister(true);
    this.generateBase64(file)
      .then((data) => {
        this.props.onVerifyQr(data)
          .then(res => {
            if (res.data && res.status === 200 && res.data.status) {
              const resData = res.data.data;
              const numbersArr = resData.system.number.match(/\d/g);
              const number = Number(numbersArr.join(''));
              const id = `${resData.system.artist}_${resData.system.piece}`;
              const searchObj = this.props.data.find(item => item.id === id);

              this.props.onPutDetails({ data: resData.public }, number);
              this.props.openDataWithPrint(searchObj, number);

              this.setState({
                loadingVerifying: false,
                successOnVerifying: true,
              }, () => {
                this.props.switchRegister(res);
                this.props.onDisableRegister();
              });
            } 
            else if (res.data) {
              this.setState({
                loadingVerifying: false,
                errorOnVerifying: res.data.message || res.data.errorMessage,
              });
              this.props.onDisableRegister();
            }
            else {
              this.setState({
                loadingVerifying: false,
                errorOnVerifying: Errors.default,
              });
              this.props.onDisableRegister();
            }
          })
          .catch(err => {
            this.setState({
              loadingVerifying: false,
              errorOnVerifying: err.message,
            });
            this.props.onDisableRegister();
          });
      })
      .catch((err) => {
        this.setState({
          loadingVerifying: false,
          errorOnVerifying: err.message,
        });
        this.props.onDisableRegister();
      });
  }

  _renderValidateSection() {
    let element = null;
    var self = this, 
    options = this.props.data.map(function(item){
        return {label: item.title || '', value: item.id || null }
    });
    const textDirection = this.state.width < 992 ? 'below the' : 'on the right';
    const text = `Please, select and click the option ${textDirection} form to go straight to the form.`;

    switch(this.state.page) {
      case 0:
        element = (
          <div className="scroller_section validate">
            <p>You can look up the certification information using the print name and number - which will give you the publicly available certificate information, or with a photo of the QR code on the back of the print - which will give you the full certificate details. You can use the certificate information to verify the current owner of a print before you purchase it for example.</p>
            <button onClick={(e) => {
              e.preventDefault();
              this.goTo(1);
            }} className="button button-form"><span>Next</span><strong><i className="icon fas fa-angle-right" /></strong></button>
          </div>
        )
        break;
      case 1: {
        const numberItem = data.verify.number;
        const canSubmitVerify = this.state.canSubmitVerify;
        const tickIcon = !this.state.successOnVerifying ? <strong><i className="icon fas fa-angle-right" /></strong> : <strong><i className="icon fas fa-check" /></strong>;
        element = (
          <div className="scroller_section form-validation form">

            <div className={`row`}>
              <div className={`col-sm-5 dropzone ${this.props.isDisableValidation ? 'disabled_validation' : ''}`}>
                <Dropzone 
                  multiple={false}
                  accept="image/jpeg, image/png"
                  onDrop={this.onDrop.bind(this)}
                  className='dropzone-area'
                  activeClassName='dropzone-area-active'
                  acceptClassName='dropzone-area-active'
                > 
                  {this.state.files.length > 0 ? 
                    <span className="dropzone-area_filename">{this.state.files[0].name}</span> :
                    <p className="dropzone-area_text">Drop or click to upload qr image.</p>
                  }
                </Dropzone>
              </div>
              <div className="col-sm-3">
                <button
                  disabled={(!canSubmitVerify || this.state.loadingVerifying) ? true : false} 
                  className={`button button_submit button-form ${this.props.isDisableValidation ? 'disabled_validation' : ''} ${this.state.successOnVerifying ? 'button-success' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      loadingVerifying: true,
                      errorOnVerifying: '',
                      successOnVerifying: false,
                    }, () => {
                      this.tryVerifyQR(this.state.files[0]); 
                    });
                  }}
                >
                  <span>Submit</span>{this.state.loadingVerifying && !this.state.successOnVerifying ? <Loader height={20} strokeWidth={3} stroke={'#fff'} />: tickIcon}
                </button>
                {this.props.isDisableValidation && this.state.successOnVerifying && <a href="#" className="active form-validation_reset unline dark" onClick={(e) => {
                  e.preventDefault();
                  this.props.onResetAll();
                }}>reset</a>}
              </div>
            </div>
            {this.state.successOnVerifying && <span className="success-helper validating_message">{text}</span>}
            {this.state.errorOnVerifying && <span className="error-helper validating_message">{this.state.errorOnVerifying}</span>}
            <div className="row form-divider"><div className="col-sm-12">or</div></div>
              
            <Formsy
              ref="form_varify_number"
              onSubmit={(response) => {
                this.tryValidateNumber(response);
              }}
              onValid={(data, u) => {
                this.setState({ canSubmitWithNumber: true });
              }} 
              onInvalid={(data) => {
                this.setState({ canSubmitWithNumber: false });
              }}
            >
              <div className="row">
                <div className="col-md-5 col-sm-6 col-xs-12 validate-selectize_col">
                  <SimpleSelect 
                    ref="select_map"
                    options = {options}
                    placeholder = "Select a map"
                    theme = "material"
                    transitionEnter={true}
                    onValueChange={(item) => {
                      const id = item ? item.value : '';
                      this.setState({
                        id,
                      });
                    }}
                  />
                </div>
                <div className="col-sm-3 col-xs-12 group-parent">
                  <Field item={numberItem} name={numberItem.key} required={numberItem.required || false} itemKey={'number'} />
                </div>
                <div className="col-sm-3 col-xs-12">
                  <button
                    disabled={((this.state.id === '' || !this.state.canSubmitWithNumber) || this.state.loadingValidate) ? true : false} 
                    className="button button-form"
                  >
                    <span>Submit</span>{this.state.loadingValidate ? <Loader height={20} strokeWidth={3} stroke={'#fff'} />: ''} 
                  </button>
                </div>
                <div className="col-sm-12">
                  {this.state.errorOnValidate && <span className="error-helper">{this.state.errorOnValidate}</span>}
                  <div className="details_footer">
                    <button onClick={(e) => {
                      e.preventDefault();
                      this.goTo(0);
                    }} className="button button-form"><i className="icon fas fa-angle-left"></i></button>
                  </div>
                </div>
              </div>
            </Formsy>
          </div>
        )
        break;
      }
      default:
        element = <div></div>;
    }

    return element;
  }

  render() {
    return (
      <Fragment>
        <h3 className="content_title">Validation</h3>
        <div className="scroller">
          <div className="scroller_body" id="scroller-validation">
            {this._renderValidateSection()}
          </div>
        </div>
      </Fragment>
    )
  }
}
Validate.defaultProps = {
}

Validate.propTypes = {
  
}


// WEBPACK FOOTER //
// ./src/components/Validate.js